import * as React from 'react';
import { useMemo } from 'react';

import RaceProgramDailyNum from '@/components/elements/Text/RaceProgramDailyNum';
import RaceInfoIcon from '@/components/layouts/Race/Singlerace/RaceProgramInfo/RaceInfoIcon';
import { RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { Campaign } from '@/lib/microcms/model';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { raceSelector } from '@/selectors/race';

import RaceLink from './RaceLink';
import {
  Container,
  Content,
  Date,
  DeadLine,
  EntryCampaignLabel,
  Name,
  RaceInfo,
  RaceNum,
  Times,
  VelodromeName,
} from './style';

interface RaceBoxProps {
  raceProgram: RaceProgram;
  campaign?: Campaign;
  onLinkClick?: React.DOMAttributes<HTMLElement>['onClick'];
}

const RaceBox: React.FC<RaceBoxProps> = ({
  raceProgram,
  campaign,
  onLinkClick,
}) => {
  const velodrome = useMemo(
    () => getVelodromeByCode(raceProgram.velodromeCode),
    [raceProgram],
  );

  const heldRace = raceProgram.races.find(r => raceSelector(r).isHeld);

  const isReleased = Boolean(raceProgram.races.length);

  const isCanceled = useMemo(
    () => heldRace !== undefined && raceSelector(heldRace).isCanceled,
    [raceProgram],
  );

  return (
    <Container>
      <Content>
        <RaceInfo>
          <Name>
            <VelodromeName
              to={`/${
                velodrome.romanName
              }/racecard/${raceProgram.heldDate.format('YYYY-MM-DD')}`}
            >
              {velodrome.name}
            </VelodromeName>
            <RaceInfoIcon
              gradeName={raceProgram.gradeName}
              timeFrame={raceProgram.timeFrame}
              isGirls={raceProgram.isGirls}
            />
          </Name>
          <Date>
            <RaceNum>
              <RaceProgramDailyNum
                isLastDay={raceProgram.isLastDay}
                dailyNum={raceProgram.dailyNum}
              />
              {heldRace &&
                !isCanceled &&
                !raceProgram.isCanceled &&
                `${heldRace.raceNum}R`}
            </RaceNum>
            {heldRace && !isCanceled && !raceProgram.isCanceled && (
              <Times>
                <span>
                  発走
                  <time>{heldRace.startTime.format('HH:mm')}</time>
                </span>
                <DeadLine>
                  締切
                  <time>{heldRace.orderDeadline.format('HH:mm')}</time>
                </DeadLine>
              </Times>
            )}
          </Date>
        </RaceInfo>
        <RaceLink
          race={heldRace}
          isCanceled={isCanceled}
          isRaceProgramCanceled={raceProgram.isCanceled}
          isReleased={isReleased}
          heldDate={raceProgram.heldDate}
          velodromeName={velodrome.romanName}
          onClick={onLinkClick}
        />
      </Content>
      {campaign && (
        <EntryCampaignLabel to={`/campaign/${campaign.id}`}>
          キャンペーン実施中
        </EntryCampaignLabel>
      )}
    </Container>
  );
};

export default RaceBox;
